<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  {{data.message}}</mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close="false"> {{data.noText}}</button>
    <button mat-button mat-dialog-close="true" cdkFocusInitial> {{data.yesText}}</button>
  </mat-dialog-actions>